angular.module('bizmetryApp').controller('CreateBizInterceptorDialogController', function (
    $scope, $q, $mdDialog, profile,
    BizInterceptorService, ReferenceDataService, ConfigurationService, dialogService,
    BusinessEventsService
) {
    var vm = this;


    vm.profile = profile;
    vm.isSaving = false;

    // Instrumentation types (dropdown, shown when AUTOMATIC — native stub or API gateway)
    vm.loadingInstrumentationTypes = true;
    vm.instrumentationTypes = [];

    // SDK types (radio buttons, shown when MANUAL — client-integrated SDK)
    vm.loadingSdkTypes = true;
    vm.sdkTypes = [];

    vm.model = {
        name: '',
        description: '',
        instrumentationType: 'AUTOMATIC',
        transportType: 'REST_API', // selected in wizard step 1 — see TRANSPORT TYPE below
        interceptorTypeId: null,   // selection from BIZ_INSTRUMENTATION_TYPE (AUTOMATIC)
        sdkTypeId: null,           // selection from INTERCEPTOR_SDK_TYPE (MANUAL)
        enabled: true,
        environments: {},          // keyed by environment id, set below — see ENVIRONMENT PARAMETERS
        bizEventIds: []            // selected biz_event_id strings — see BIZ EVENTS below
    };

    // =====================================================================
    // WIZARD — 4 steps: pick a transport, then the existing General and
    // Environments panels (formerly two tabs in a single-view dialog), then
    // which of the profile's biz events this interceptor should capture.
    // =====================================================================

    vm.wizard = {
        stepIndex: 0,
        totalSteps: 4,
        steps: [
            { label: 'Transport Type' },
            { label: 'General' },
            { label: 'Tuning' },
            { label: 'Biz Instrumentation' }
        ]
    };

    // =====================================================================
    // BIZ EVENTS — which of the profile's biz events this interceptor
    // should capture traffic for (see biz-event-picker/BizEventPicker.js).
    //
    // Default selection is every biz event EXCEPT ones already captured by
    // another interceptor of this profile — a biz event's operations are
    // normally deployed/captured in exactly one place (one app, one
    // downloaded interceptor SDK); two interceptors both claiming the same
    // biz event is a real but edge-case scenario (e.g. the same operation
    // genuinely exposed through two different apps), not the common case,
    // so it shouldn't be the default. vm.capturedElsewhereBy — a biz event
    // id -> [interceptor names already capturing it] map (that interceptor's
    // own bizEventIds === null counts as "all of them", same unrestricted
    // convention as everywhere else) — is also passed to the picker purely
    // so it can flag those rows with WHERE it's already captured, but
    // doesn't block selecting one anyway if the user really does want the
    // overlap.
    // =====================================================================

    vm.loadingBizEvents = true;
    vm.bizEvents = [];
    var allBizEvents = [];
    function refreshBizEvents() {
        vm.bizEvents = BusinessEventsService.filterByTransport(allBizEvents, vm.model.transportType);
        vm.model.bizEventIds = vm.bizEvents
            .filter(function (e) { return !vm.capturedElsewhereBy[e.biz_event_id]; })
            .map(function (e) { return e.biz_event_id; });
    }
    $scope.$watch('vm.model.transportType', function (value, previous) {
        if (value !== previous) refreshBizEvents();
    });
    vm.capturedElsewhereBy = {};

    $q.all({
        events: BusinessEventsService.getAllForProfile(vm.profile.id)
            .catch(function (error) {
                console.error('[CreateBizInterceptorDialog] Error loading biz events:', error);
                return [];
            }),
        existingInterceptors: BizInterceptorService.listByProfile(vm.profile.id, { size: 1000 })
            .then(function (r) { return (r.data && r.data.content) || []; })
            .catch(function (error) {
                console.error('[CreateBizInterceptorDialog] Error loading existing interceptors:', error);
                return [];
            })
    }).then(function (results) {
        allBizEvents = results.events || [];

        var capturedBy = {};
        function markCaptured(bizEventId, interceptorName) {
            if (!capturedBy[bizEventId]) { capturedBy[bizEventId] = []; }
            if (capturedBy[bizEventId].indexOf(interceptorName) === -1) {
                capturedBy[bizEventId].push(interceptorName);
            }
        }
        results.existingInterceptors.forEach(function (ic) {
            if (ic.biz_event_ids == null) {
                // Unrestricted — this interceptor already captures every
                // biz event of the profile.
                BusinessEventsService.filterByTransport(allBizEvents, ic.transport_type || 'REST_API')
                    .forEach(function (e) { markCaptured(e.biz_event_id, ic.biz_interceptor_name); });
            } else {
                ic.biz_event_ids.forEach(function (id) { markCaptured(id, ic.biz_interceptor_name); });
            }
        });
        vm.capturedElsewhereBy = capturedBy;

        refreshBizEvents();
    }).finally(function () {
        vm.loadingBizEvents = false;
    });

    // =====================================================================
    // TRANSPORT TYPE — catalog from reference data; REST API is the only one
    // implemented for now, the others are visible but disabled until their
    // connectors exist (see BizInterceptorService#describeTransport).
    // =====================================================================

    vm.transportTypes = [];
    vm.loadingTransportTypes = true;
    BizInterceptorService.getTransportTypes()
        .then(function (types) { vm.transportTypes = types; })
        .catch(function (error) {
            console.error('[CreateBizInterceptorDialog] Error loading transport types:', error);
        })
        .finally(function () { vm.loadingTransportTypes = false; });

    vm.selectTransportType = function (t) {
        if (!t.enabled) { return; }
        vm.model.transportType = t.id;
    };

    // Selected transport — shown in the toolbar once past step 0.
    vm.selectedTransportType = function () {
        return vm.model.transportType ? BizInterceptorService.describeTransport(vm.model.transportType) : null;
    };

    // =====================================================================
    // WIZARD NAVIGATION
    // =====================================================================

    vm.gotoStep = function (idx) {
        if (idx <= vm.wizard.stepIndex) { vm.wizard.stepIndex = idx; }
    };

    vm.canAdvance = function () {
        if (vm.wizard.stepIndex === 0) { return !!vm.model.transportType; }
        return vm.isFormValid();
    };

    vm.nextStep = function () {
        if (!vm.canAdvance()) { return; }
        if (vm.wizard.stepIndex < vm.wizard.totalSteps - 1) { vm.wizard.stepIndex++; }
    };

    vm.prevStep = function () {
        if (vm.wizard.stepIndex > 0) { vm.wizard.stepIndex--; }
    };

    vm.isLastStep = function () {
        return vm.wizard.stepIndex === vm.wizard.totalSteps - 1;
    };

    // Footer primary button: advance to the next step, or create the
    // interceptor from the last step.
    vm.primaryAction = function () {
        if (vm.isLastStep()) { vm.createNewBizInterceptor(); } else { vm.nextStep(); }
    };

    function byDescAsc(a, b) {
        return (a.refObjectDesc || a.refObjectLabel || '').localeCompare(b.refObjectDesc || b.refObjectLabel || '');
    }

    // =====================================================================
    // ENVIRONMENT PARAMETERS — fine-tuning + network knobs are per
    // environment (a setup that works for DEV can be wrong for PROD), one
    // config bucket per environment.id on the profile this interceptor is
    // being created under. min/max/default per knob still come from the
    // platform config (frontend.biz-interceptor.<param>.{min,max,default}
    // in the deployment ConfigMap), same idiom as the Agent Configuration
    // dialog — the literals below are only a fallback if a key is missing.
    // =====================================================================

    vm.environments = vm.profile.environments || [];

    var CORE_PARAM_KEYS = [
        'bufferMaxSize', 'bufferMaxSizeMb', 'syncBatchSize', 'syncBatchSizeMax', 'syncIntervalSeconds',
        'heartbeatIntervalSeconds', 'transmitWorkerCount', 'transmitWorkerCountMax',
        'backpressureScaleDownThresholdPct', 'backpressureScaleUpThresholdPct', 'reconnectIntervalSeconds',
        'dataRetentionDays'
    ];
    function getConfig(key, fallback) {
        var value = ConfigurationService.getFromCache(key);
        return (value === null || value === undefined) ? fallback : Number(value);
    }

    function _paramLimit(name, fallbackMin, fallbackMax, fallbackDef) {
        var base = 'frontend.biz-interceptor.' + name + '.';
        var min = getConfig(base + 'min', fallbackMin);
        var max = getConfig(base + 'max', fallbackMax);
        var def = getConfig(base + 'default', fallbackDef);
        return { min: min, max: max, def: def, step: Math.max(1, Math.floor((max - min) * 0.01)) };
    }

    vm.limits = {
        bufferMaxSize:            _paramLimit('buffer_max_size',            100, 100000, 10000),
        bufferMaxSizeMb:          _paramLimit('buffer_max_size_mb',           1,   4096,    64),
        syncBatchSize:            _paramLimit('sync_batch_size',             10,  50000,  1024),
        syncBatchSizeMax:         _paramLimit('sync_batch_size_max',         10,  50000, 10240),
        syncIntervalSeconds:      _paramLimit('sync_interval_seconds',        1,    300,    30),
        heartbeatIntervalSeconds: _paramLimit('heartbeat_interval_seconds',   5,    600,    60),
        transmitWorkerCount:      _paramLimit('transmit_worker_count',        1,     64,     4),
        transmitWorkerCountMax:   _paramLimit('transmit_worker_count_max',    1,     64,    16),
        backpressureScaleDownThresholdPct: _paramLimit('backpressure_scale_down_threshold_pct', 0, 100, 20),
        backpressureScaleUpThresholdPct:   _paramLimit('backpressure_scale_up_threshold_pct',   0, 100, 70),
        reconnectIntervalSeconds: _paramLimit('reconnect_interval_seconds',   1,    300,    15),
        dataRetentionDays:        _paramLimit('data_retention_days',          1,     60,    30)
    };

    function _defaultParams(keys) {
        var params = {};
        keys.forEach(function (key) { params[key] = vm.limits[key].def; });
        params.discoveryMode = false;
        params.discoveryHttpMethods = ["GET", "POST", "PUT", "PATCH", "DELETE"];
        return params;
    }

    function _defaultEnvironmentConfig() {
        return {
            enabled: false,
            parameters: _defaultParams(CORE_PARAM_KEYS)
        };
    }

    vm.environments.forEach(function (env) {
        vm.model.environments[env.id] = _defaultEnvironmentConfig();
    });

    // Master/detail layout: left-side list of environments, right-side
    // shows whichever one is selected — avoids a long "spreadsheet" of
    // every environment's sliders stacked and scrolled through at once.
    vm.selectedEnvironment = vm.environments.length ? vm.environments[0] : null;

    vm.selectEnvironment = function (env) {
        vm.selectedEnvironment = env;
    };

    // A disabled environment can't have its configuration touched — only
    // relevant while it's off; re-enabling it re-enables the controls too.
    vm.isSelectedEnvironmentDisabled = function () {
        return !!vm.selectedEnvironment && !vm.model.environments[vm.selectedEnvironment.id].enabled;
    };

    // Initial Sync Batch Size can never exceed either the current Buffer Max
    // Size (a batch larger than the buffer itself makes no sense) or the
    // current Max Sync Batch Size (Self-Tuning's own floor/ceiling pair) —
    // this is the effective ceiling the slider/input use instead of the raw
    // config max. It's also now just the STARTING point the backpressure
    // auto-tuner floats up on its own at runtime once traffic pushes
    // pressure up — see the field's own tooltip below.
    vm.batchCapacityLimits = {};
    vm.loadingBatchCapacity = true;
    vm.batchCapacityError = null;
    vm.batchSizeCeiling = function (envId) {
        var cap = vm.batchCapacityLimits[envId];
        return Math.min(vm.limits.syncBatchSizeMax.max, cap == null ? Infinity : cap);
    };
    vm.batchSizeMinimum = function (envId, key) {
        return Math.min(vm.limits[key].min, vm.batchSizeCeiling(envId));
    };
    function loadBatchCapacity() {
        return BizInterceptorService.getBatchCapacityLimits(vm.profile).then(function (limits) {
            vm.batchCapacityLimits = limits;
            Object.keys(vm.model.environments).forEach(function (envId) { vm.onSyncBatchSizeMaxChange(envId); });
        }).catch(function () {
            vm.batchCapacityError = 'Could not verify the linked agent batch limits. Reopen this dialog to retry.';
        }).finally(function () { vm.loadingBatchCapacity = false; });
    }

    vm.syncBatchSizeMax = function (envId) {
        var p = vm.model.environments[envId].parameters;
        return Math.min(vm.limits.syncBatchSize.max, p.bufferMaxSize, p.syncBatchSizeMax, vm.batchSizeCeiling(envId));
    };

    // Initial Transmit Worker Count can never exceed this same environment's
    // own configured Max — same dynamic-ceiling idiom as Sync Batch Size
    // above, just against a sibling field instead of a different one.
    vm.transmitWorkerCountInitialMax = function (envId) {
        return Math.min(vm.limits.transmitWorkerCount.max, vm.model.environments[envId].parameters.transmitWorkerCountMax);
    };

    // Worker Scale-Down Pressure Threshold (P1) can never exceed the
    // current Scale-Up threshold (P2) — same dynamic-ceiling idiom as
    // Initial Transmit Worker Count above.
    vm.backpressureScaleDownThresholdMax = function (envId) {
        return Math.min(vm.limits.backpressureScaleDownThresholdPct.max, vm.model.environments[envId].parameters.backpressureScaleUpThresholdPct);
    };

    // Keeps a manually-typed value within [min, max] on blur/change — same
    // idiom as the Agent Configuration dialog's clampValue(). `section` is
    // always 'parameters'. Initial Sync Batch Size, Initial
    // Transmit Worker Count, and the Scale-Down threshold each use their own
    // dynamic, sibling-field-aware ceiling above instead of their plain
    // config max.
    vm.clampParam = function (envId, section, key) {
        var limit = vm.limits[key];
        var bucket = vm.model.environments[envId][section];
        var max = limit.max;
        if (key === 'syncBatchSize') { max = vm.syncBatchSizeMax(envId); }
        else if (key === 'syncBatchSizeMax') { max = vm.batchSizeCeiling(envId); }
        else if (key === 'transmitWorkerCount') { max = vm.transmitWorkerCountInitialMax(envId); }
        else if (key === 'backpressureScaleDownThresholdPct') { max = vm.backpressureScaleDownThresholdMax(envId); }
        var value = bucket[key];
        if (typeof value === 'string') { value = parseFloat(value); }
        if (value === null || value === undefined || isNaN(value)) { value = limit.def; }
        else if (value < limit.min) { value = limit.min; }
        else if (value > max) { value = max; }
        bucket[key] = Math.min(value, max);
    };

    // If Buffer Max Size drops below the current Initial Sync Batch Size,
    // pull the batch size down to match so the two stay consistent.
    vm.onBufferMaxSizeChange = function (envId) {
        var cfg = vm.model.environments[envId];
        if (cfg.parameters.syncBatchSize > vm.syncBatchSizeMax(envId)) {
            cfg.parameters.syncBatchSize = vm.syncBatchSizeMax(envId);
        }
    };

    // If Max Sync Batch Size drops below the current Initial, pull Initial
    // down to match — same idiom as onBufferMaxSizeChange above.
    vm.onSyncBatchSizeMaxChange = function (envId) {
        var cfg = vm.model.environments[envId];
        cfg.parameters.syncBatchSizeMax = Math.min(cfg.parameters.syncBatchSizeMax, vm.batchSizeCeiling(envId));
        if (cfg.parameters.syncBatchSize > vm.syncBatchSizeMax(envId)) {
            cfg.parameters.syncBatchSize = vm.syncBatchSizeMax(envId);
        }
    };

    // If Max Transmit Worker Count drops below the current Initial, pull
    // Initial down to match so the two stay consistent — same idiom as
    // onBufferMaxSizeChange above.
    vm.onTransmitWorkerCountMaxChange = function (envId) {
        var cfg = vm.model.environments[envId];
        if (cfg.parameters.transmitWorkerCount > vm.transmitWorkerCountInitialMax(envId)) {
            cfg.parameters.transmitWorkerCount = vm.transmitWorkerCountInitialMax(envId);
        }
    };

    // If the Scale-Up threshold drops below the current Scale-Down
    // threshold, pull Scale-Down down to match — same idiom as
    // onTransmitWorkerCountMaxChange above.
    vm.onBackpressureScaleUpThresholdChange = function (envId) {
        var cfg = vm.model.environments[envId];
        if (cfg.parameters.backpressureScaleDownThresholdPct > vm.backpressureScaleDownThresholdMax(envId)) {
            cfg.parameters.backpressureScaleDownThresholdPct = vm.backpressureScaleDownThresholdMax(envId);
        }
    };

    vm.resetEnvironmentParameters = function (envId) {
        var cfg = vm.model.environments[envId];
        cfg.parameters = _defaultParams(CORE_PARAM_KEYS);
        vm.onSyncBatchSizeMaxChange(envId);
    };

    // =====================================================================
    // LOAD REFERENCE DATA — both catalogs, since either may be needed
    // depending on which instrumentation type the user picks
    // =====================================================================

    ReferenceDataService.getReferenceData('BIZ_INSTRUMENTATION_TYPE')
        .then(function (response) {
            vm.instrumentationTypes = (response.data || []).sort(byDescAsc);
        })
        .catch(function (error) {
            console.error('[CreateBizInterceptorDialog] Error loading instrumentation types:', error);
            vm.instrumentationTypes = [];
        })
        .finally(function () {
            vm.loadingInstrumentationTypes = false;
        });

    ReferenceDataService.getReferenceData('INTERCEPTOR_SDK_TYPE')
        .then(function (response) {
            vm.sdkTypes = (response.data || []).sort(byDescAsc);
        })
        .catch(function (error) {
            console.error('[CreateBizInterceptorDialog] Error loading SDK types:', error);
            vm.sdkTypes = [];
        })
        .finally(function () {
            vm.loadingSdkTypes = false;
        });

    // =====================================================================
    // WATCH instrumentationType — clear the other branch's selection
    // =====================================================================

    $scope.$watch('vm.model.instrumentationType', function (newVal, oldVal) {
        if (newVal === oldVal) { return; }
        vm.model.interceptorTypeId = null;
        vm.model.sdkTypeId = null;
    });

    // =====================================================================
    // HELPERS
    // =====================================================================

    vm.isManual = function () {
        return vm.model.instrumentationType === 'MANUAL';
    };

    vm.getSelectedInterceptorType = function () {
        if (!vm.model.interceptorTypeId) { return null; }
        return vm.instrumentationTypes.find(function (t) { return t.refId === vm.model.interceptorTypeId; }) || null;
    };

    vm.getSelectedSdkType = function () {
        if (!vm.model.sdkTypeId) { return null; }
        return vm.sdkTypes.find(function (t) { return t.refId === vm.model.sdkTypeId; }) || null;
    };

    // =====================================================================
    // NAME GENERATION — {profile}-{Automatic/Manual}-{type}-{time-serial}
    // Generated as soon as the dialog opens, then kept in sync as the user
    // picks an Instrumentation/Interceptor/SDK Type — unless they've
    // manually edited the Name field, in which case we stop touching it.
    // If the type's label would make the name too long, we fall back to
    // an acronym of that label (first letter of each word) instead.
    // =====================================================================

    var MAX_NAME_LEN = 120;
    vm._nameTouched = false;

    vm.existingNames = [];       // lowercased biz_interceptor_name values across the WHOLE ACCOUNT
    vm.nameAlreadyExists = false;
    vm.loadingNames = true;

    // profile_id omitted on purpose — the backend's uniqueness constraint
    // (BizInterceptorServiceImpl#create) is existsByBizInterceptorNameAndAccountId,
    // account-wide rather than per-profile, so this pre-check has to match
    // that scope or a name colliding with an interceptor in a different
    // profile of the same account would pass here and only fail on submit.
    BizInterceptorService.listByProfile(null, { size: 1000 })
        .then(function (response) {
            var list = (response.data && response.data.content) || [];
            vm.existingNames = list.map(function (i) {
                return (i.biz_interceptor_name || '').trim().toLowerCase();
            });
        })
        .catch(function () { vm.existingNames = []; })
        .finally(function () {
            vm.loadingNames = false;
            // Whatever is in the Name field right now (auto-generated while
            // this was still loading, or already typed by the user) was
            // checked against an empty list up to this point — re-validate
            // it against the list that just arrived instead of waiting for
            // the next keystroke to notice a collision.
            vm.onNameChange();
        });

    function _slug(str, maxLen) {
        return (str || '')
            .toString()
            .trim()
            .replace(/[^a-zA-Z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '')
            .substring(0, maxLen || 40);
    }

    // Acronym from the first letter of every word — used when the type
    // label would otherwise make the generated name too long.
    function _acronym(str) {
        return (str || '')
            .toString()
            .trim()
            .split(/\s+/)
            .map(function (word) { return word.charAt(0).toUpperCase(); })
            .join('');
    }

    function _timeSerial() {
        return Date.now().toString(36);
    }

    function _selectedTypeLabel() {
        var selected = vm.isManual() ? vm.getSelectedSdkType() : vm.getSelectedInterceptorType();
        return selected ? (selected.refObjectDesc || selected.refObjectLabel || '') : '';
    }

    vm.onNameChange = function () {
        var trimmed = (vm.model.name || '').trim().toLowerCase();
        vm.nameAlreadyExists = trimmed.length > 0 && vm.existingNames.indexOf(trimmed) !== -1;
    };

    vm.onNameEdited = function () {
        vm._nameTouched = true;
        vm.onNameChange();
    };

    vm.regenerateName = function () {
        var profileSlug = _slug(vm.profile.profileName || vm.profile.name, 40);
        var typeWord = vm.isManual() ? 'Manual' : 'Automatic';
        var typeLabel = _selectedTypeLabel();
        var serial = _timeSerial();

        function assemble(typePart) {
            return [profileSlug, typeWord, typePart, serial]
                .filter(function (p) { return !!p; })
                .join('-');
        }

        var name = assemble(_slug(typeLabel, 40));
        if (name.length > MAX_NAME_LEN && typeLabel) {
            name = assemble(_acronym(typeLabel));
        }

        vm.model.name = name.substring(0, MAX_NAME_LEN);
        vm._nameTouched = false;
        vm.onNameChange();
    };

    // =====================================================================
    // DESCRIPTION GENERATION — "Captures API traffic for the {profile}
    // profile via {automatic/manual} business instrumentation using
    // {interceptor/SDK type}, feeding this profile's configured biz
    // events." Same touched/regenerate gating as Name, kept independent —
    // editing one doesn't stop the other from updating.
    // =====================================================================

    var MAX_DESCRIPTION_LEN = 255;
    vm._descriptionTouched = false;

    vm.onDescriptionEdited = function () {
        vm._descriptionTouched = true;
    };

    vm.regenerateDescription = function () {
        var profileName = vm.profile.profileName || vm.profile.name || '';
        var modeWord = vm.isManual() ? 'manual' : 'automatic';
        var typeLabel = _selectedTypeLabel() || (vm.isManual() ? 'the selected SDK' : 'the selected interceptor type');

        var description = 'Captures API traffic for the ' + profileName + ' profile via '
            + modeWord + ' business instrumentation using ' + typeLabel
            + ', feeding this profile\'s configured biz events.';

        vm.model.description = description.substring(0, MAX_DESCRIPTION_LEN);
        vm._descriptionTouched = false;
    };

    // Auto-regenerate name/description whenever the type selection changes,
    // as long as the user hasn't manually edited that particular field —
    // mirrors the same touched/generated gating used in the Create Profile
    // wizard.
    $scope.$watchGroup(
        ['vm.model.instrumentationType', 'vm.model.interceptorTypeId', 'vm.model.sdkTypeId'],
        function () {
            if (!vm._nameTouched) { vm.regenerateName(); }
            if (!vm._descriptionTouched) { vm.regenerateDescription(); }
        }
    );

    // Initial generation — profile is already known even before any type
    // is picked, so the name/description fields aren't left blank on open.
    vm.regenerateName();
    vm.regenerateDescription();

    // =====================================================================
    // FORM VALIDATION — a type selection is always required, just from
    // whichever catalog matches the chosen instrumentation type
    // =====================================================================

    vm.isFormValid = function () {
        if (vm.loadingBatchCapacity || vm.batchCapacityError) { return false; }
        var isNameValid = vm.model.name && vm.model.name.trim() !== '';
        var isTypeValid = vm.isManual() ? !!vm.model.sdkTypeId : !!vm.model.interceptorTypeId;
        return !!vm.model.transportType && isNameValid && isTypeValid && !vm.nameAlreadyExists && !vm.loadingNames;
    };

    // =====================================================================
    // CANCEL
    // =====================================================================

    loadBatchCapacity();

    vm.cancel = function () { $mdDialog.cancel('cancel'); };

    // =====================================================================
    // CREATE
    // =====================================================================

    vm.createNewBizInterceptor = function () {
        if (vm.isSaving || !vm.isFormValid()) { return; }

        vm.isSaving = true;

        var selectedType = vm.isManual() ? vm.getSelectedSdkType() : vm.getSelectedInterceptorType();

        var dto = {
            biz_interceptor_name: (vm.model.name || '').trim(),
            biz_interceptor_description: (vm.model.description || '').trim(),
            profile_id: vm.profile.id,
            instrumentation_type: vm.model.instrumentationType,
            transport_type: vm.model.transportType,
            // "name" carries the stable ref_object_label (the backend
            // discriminates by it); "description" is the human-readable
            // text, stored too so list/detail views never need to re-
            // resolve it against the reference-data catalog.
            interceptor_type: selectedType
                ? { id: selectedType.refId, name: selectedType.refObjectLabel, description: selectedType.refObjectDesc || selectedType.refObjectLabel }
                : null,
            enabled: vm.model.enabled,
            environments: vm.environments.map(function (env) {
                var cfg = vm.model.environments[env.id];
                return {
                    id: env.id,
                    enabled: !!cfg.enabled,
                    parameters: {
                        discovery_mode:             false,
                        discovery_http_methods: cfg.parameters.discoveryHttpMethods.slice(),
                        buffer_max_size:            cfg.parameters.bufferMaxSize,
                        buffer_max_size_mb:         cfg.parameters.bufferMaxSizeMb,
                        sync_batch_size:            cfg.parameters.syncBatchSize,
                        sync_batch_size_max:        cfg.parameters.syncBatchSizeMax,
                        sync_interval_seconds:      cfg.parameters.syncIntervalSeconds,
                        heartbeat_interval_seconds: cfg.parameters.heartbeatIntervalSeconds,
                        transmit_worker_count:      cfg.parameters.transmitWorkerCount,
                        transmit_worker_count_max:  cfg.parameters.transmitWorkerCountMax,
                        backpressure_scale_down_threshold_pct: cfg.parameters.backpressureScaleDownThresholdPct,
                        backpressure_scale_up_threshold_pct:   cfg.parameters.backpressureScaleUpThresholdPct,
                        reconnect_interval_seconds: cfg.parameters.reconnectIntervalSeconds,
                        data_retention_days:        cfg.parameters.dataRetentionDays
                    }
                };
            }),
            biz_event_ids: (vm.model.bizEventIds || []).slice()
        };

        BizInterceptorService.create(dto)
            .then(function () {
                $mdDialog.hide(true);
            })
            .catch(function (err) {
                console.error('Error creating biz interceptor:', err);
                vm.isSaving = false;
                var errorMessage = 'An error occurred while creating the biz interceptor.';
                if (err.data && err.data.message) { errorMessage = err.data.message; }
                else if (err.statusText) { errorMessage = err.statusText; }
                dialogService.showErrorDialog('Create Failed', errorMessage);
            });
    };

});
